import{getDefaultExportFromCjs as o}from"./_commonjsHelpers.mjs";import{__require as r}from"../us_zipcode/Lookup.mjs";var m=o(r());export{m as default};
